/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import { qreq } from "../../../shared/qrequest";
import Alert from "../../Alert";
import BaseCom from "../../BaseCom";
import L from "../../Lang";

export default class GooglePay extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {
                processType: 'gp',
            }
        }
        this.containerRef = React.createRef();
    }

    async componentDidMount() {
        await this.getSettings();
        this.setState({ info: { ...this.state.info, cardHolderName: this.props.session.firstName + ' ' + this.props.session.lastName } });
        setTimeout(() => {
            this.load();
        }, 500);
    }

    load = async () => {
        try {
            let j = await qreq.postAsync('/api/merchant/details', this.props.session);
            if (!j.item) { // error out
                this.alert(j.errorMessage);
                return;
            }

            // TODO: Validate google pay enabled

            this.setState({ loaded: true });

            let script = document.createElement('script');
            script.src = 'https://pay.google.com/gp/p/js/pay.js';
            script.async = true;
            script.onload = () => {
                setTimeout(() => {
                    this.client = new window.google.payments.api.PaymentsClient({ environment: 'PRODUCTION' }); // 'PRODUCTION' or 'TEST'
                    const button = this.client.createButton({ onClick: this.buttonClick });
                    this.containerRef.current.appendChild(button);
                }, 500);
            };
            document.head.appendChild(script);

        }
        catch (e) {
            console.error(e);
        }


    }

    buttonClick = async () => {
        const money = (n) => (Number(n || 0)).toFixed(2);

        const baseRequest = { apiVersion: 2, apiVersionMinor: 0 };

        const allowedCardNetworks = ["AMEX", "DISCOVER", "JCB", "MASTERCARD", "VISA"];
        const allowedCardAuthMethods = ["PAN_ONLY", "CRYPTOGRAM_3DS"];

        const tokenizationSpecification = {
            type: "PAYMENT_GATEWAY",
            parameters: {
                gateway: "paradigmpay",
                gatewayMerchantId: "3352176248133416859"
            }
        };

        const cardPaymentMethod = {
            type: "CARD",
            parameters: {
                allowedAuthMethods: allowedCardAuthMethods,
                allowedCardNetworks: allowedCardNetworks,
                billingAddressRequired: true,
                billingAddressParameters: { format: "FULL" }
            },
            tokenizationSpecification
        };

        const paymentDataRequest = {
            ...baseRequest,
            allowedPaymentMethods: [cardPaymentMethod],
            merchantInfo: {
                merchantName: "Paradigm Services Inc",
                merchantId: "3352176248133416859" // only if you actually have one
            },
            transactionInfo: {
                countryCode: "US",
                currencyCode: "USD",
                totalPriceStatus: "FINAL",
                totalPrice: money(this.props.session.total),
                totalPriceLabel: "Total"
                // displayItems: [...] // omit unless you KNOW it's accepted in your environment
            }
        };

        console.log("Payment Data Request", paymentDataRequest);

        try {
            const paymentData = await this.client.loadPaymentData(paymentDataRequest);
            await this.pay(paymentData);
        } catch (err) {
            console.error("Google Pay loadPaymentData error", err);
            this.alert(err?.statusCode ? `${err.statusCode}: ${err.statusMessage}` : (err?.message || String(err)));
        }
    };


    pay = async (e) => {
        let token = e.paymentMethodData.tokenizationData.token;
        console.log("Token sent", token);

        let info = { ...this.state.info };
        info.processType = 'gp';
        info.merchantID = this.props.session.merchantID;
        info.terminalID = this.props.session.terminalID;
        info.userID = this.props.session.userID;
        info.amount = this.props.session.amount;
        info.totalTax = this.props.session.totalTax;
        info.sid = this.props.session.sid;
        info.payToken = token;

        this.setState({ submitting: true });
        try {
            let j = await qreq.postAsync('/api/payment/process', info);
            if (j.item)
                this.props.onSuccess(j.item);
            else
                this.props.onError(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    change = () => {
        this.setState({ info: { ...this.state.info } });
    }

    render() {
        return <div>
            <div className="row">
                <div className="col-md-12">
                    <h2>Google Pay</h2>
                    <div className="text-center" ref={this.containerRef}></div>
                    {this.state.error && <Alert type="danger">{this.state.error}</Alert>}
                </div>
            </div>
            <div className="d-grid my-2">
                <button type="button" className="btn btn-lg" onClick={this.props.onCancel}><L>Select a different Payment Method</L></button>
            </div>
        </div>;
    }
}